<template>
  <button type="button" class="btn btn-sm"
          :class="error ? 'btn-danger' : (copied ? 'btn-success' : 'btn-outline-primary')"
          :title="copied ? 'Link copied!' : (error ? 'Copy failed' : 'Copy a shareable link to this update')"
          @click="copyLink">
    <span v-if="error"><span class="fas fa-exclamation-triangle"></span></span>
    <span v-else-if="copied"><span class="fas fa-check"></span></span>
    <span v-else><span class="fas fa-link"></span></span>
  </button>
</template>

<script>
export default {
  name: 'CopyReleaseLinkButton',
  props: {
    releaseId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      copied: false,
      error: false,
      timer: null
    }
  },
  methods: {
    async copyLink () {
      // Hash router: resolve() returns "#/updates/<id>". Prepend origin +
      // pathname so the copied link is a full, shareable absolute URL that
      // deep-links straight to this release (the router's scrollBehavior
      // scrolls it into view - see router/index.js).
      const resolved = this.$router.resolve({ name: 'Updates', params: { releaseId: this.releaseId } })
      const url = window.location.origin + window.location.pathname + resolved.href

      try {
        await navigator.clipboard.writeText(url)
        if (this.timer) clearTimeout(this.timer)
        this.error = false
        this.copied = true
        this.timer = setTimeout(() => { this.copied = false }, 2000)
      } catch (e) {
        console.error('Clipboard write failed:', e)
        if (this.timer) clearTimeout(this.timer)
        this.copied = false
        this.error = true
        this.timer = setTimeout(() => { this.error = false }, 3000)
      }
    }
  },
  beforeUnmount () {
    if (this.timer) clearTimeout(this.timer)
  }
}
</script>
